import { Observable, of } from 'rxjs';
import { map, catchError, switchMap } from 'rxjs/operators';
import { ComponentDataSourceService } from '../../component-data-source.service';
import { LoadDataParams } from '../../../../interfaces/DataSource/DataSourceParams.interface';
import { EventCateringApprovalListItemDTO } from '../../../../dto/event/event-catering-approval-list-item.dto';
import { Router } from '@angular/router';
import {
  buildCateringApprovalStatusColumn,
  buildCateringApproveIconColumn,
  buildCateringApprovedAtColumn,
  buildCateringDualCountColumns,
  buildCateringNameLocationColumns,
  buildCateringPreferencesIconColumn,
  buildCateringTableOptions,
  buildEventScheduleColumn,
  buildEventViewIconColumn,
  CATERING_EVENT_LIST_TABLE_BASE,
  loadCateringGroupFilterOptions,
} from './duna_catering_list.shared';

export function duna_catering_pending(componentDataSourceService: ComponentDataSourceService) {
  const router = componentDataSourceService.injector.get(Router);
  const http = componentDataSourceService.http;

  const tableSettings = {
    columns: [
      buildEventScheduleColumn(),
      ...buildCateringNameLocationColumns(),
      ...buildCateringDualCountColumns(),
      buildCateringApprovedAtColumn(),
      buildCateringApprovalStatusColumn(),
      buildCateringPreferencesIconColumn(),
      buildEventViewIconColumn(router),
      buildCateringApproveIconColumn(),
    ],
    ...CATERING_EVENT_LIST_TABLE_BASE,
  };

  return {
    name: 'DUNA Catering Pending',
    description: 'Events med catering_included der afventer godkendelse (eller kræver gen-godkendelse)',
    execute: (params?: LoadDataParams): Observable<any> => {
      return loadCateringGroupFilterOptions(http).pipe(
        switchMap((groupOptions) => {
          const mergedFilters = [...(params?.filters || [])];
          if (!mergedFilters.some(f => f.column === 'status')) {
            mergedFilters.push({ column: 'status', value: 'pending', operator: 'equals' } as any);
          }
          if (!mergedFilters.some(f => f.column === 'include_no_participants')) {
            mergedFilters.push({ column: 'include_no_participants', value: true, operator: 'equals' } as any);
          }

          const requestParams: LoadDataParams = {
            ...(params || ({ } as any)),
            dataSourceKey: 'duna_catering_pending',
            filters: mergedFilters
          };

          return componentDataSourceService['loadDataWithStandardFiltersGET'](
            'duna_catering_pending',
            '/events/catering',
            requestParams
          ).pipe(
            catchError(error => {
              console.error('Error fetching pending catering approvals:', error);
              return of({ items: [], totalCount: 0, pageSize: 10, pageIndex: 0 });
            }),
            map(result => {
              const items = (result?.items || []) as EventCateringApprovalListItemDTO[];
              return {
                items,
                totalCount: result?.totalCount ?? items.length,
                pageSize: result?.pageSize ?? 10,
                pageIndex: result?.pageIndex ?? 0,
                filters: result?.filters,
                settings: {
                  ...tableSettings,
                  tableOptions: buildCateringTableOptions(groupOptions, params)
                }
              };
            })
          );
        })
      );
    },
    settings: {
      ...tableSettings,
      tableOptions: buildCateringTableOptions([], undefined)
    }
  };
}
